import gql from 'graphql-tag'

export const ARCHIVE_MEDIA = gql`
  mutation archiveMedia($id: Int!) {
    archiveMedia(id: $id) {
      id
    }
  }
`

export const UPLOAD_MEDIA = gql`
  mutation uploadMedia($file: Upload!, $serviceFkey: String!, $metadata: Json, $nutritionMenuItemId: Int) {
    uploadMedia(
      media: $file
      serviceFkey: $serviceFkey
      type: "full"
      await: true
      metadata: $metadata
      nutritionMenuItemId: $nutritionMenuItemId
    ) {
      url
      id
      coverUrl
      thumbUrl
      metadata
    }
  }
`
